module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/de7Baj/tc-custom/9781526753120.jpg?1716521889729",
      "alt": "This image is the cover for the book Hitler's Wolfsschanze"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hitler's Wolfsschanze\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This detailed guide to Hitler’s secret Prussian headquarters is fully illustrated with historic photos and rare color images of how it appears today.")]), _c('br'), _c('br'), _vm._v(" Set deep in the Masurian woods of northern Poland, formally East Prussia, lies a vast complex of ruined bunkers known as the "), _c('i', [_vm._v("Wolfsschanze ")]), _vm._v("or Wolf’s Lair. This was Hitler’s headquarters for the German attack on the Soviet Union in 1941. It is also where Colonel von Stauffenberg almost killed Hitler in the summer of 1944."), _c('br'), _c('br'), _vm._v(" Built in under total secrecy, the Wolfsschanze was camouflaged with artificial grass and trees. Drawing on a unique collection of color photographs, "), _c('i', [_vm._v("Hitler’s Wolfsschanze")]), _vm._v(" presents a detailed tour of the 2.5 square mile campus as it appears today—with each building and its purpose identified. Laced with personal accounts of the installation and Hitler’s routines, the Wolfsschanze is brought to life once more."), _c('br'), _c('br'), _vm._v(" Yet the Wolfsschanze was not the only German military complex in this small part of the Eastern Front. This comprehensive volume also shows and describes the German Army’s headquarters at Mauerwald, the Luftwaffe’s headquarters near the current Russian border, and those of the SS and the Reich Chancellery, both situated near the Wolfsschanze. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Grehan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Frontline Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0